var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrpIcone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 38.316 17.16 v -5.043 c 0 -4.592 -3.723 -8.316 -8.315 -8.316 s -8.315 3.723 -8.315 8.316 v 5.043 c 0 4.592 3.723 8.315 8.315 8.315 S 38.316 21.753 38.316 17.16 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(194,173,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 68.317 17.16 v -5.043 c 0 -4.592 -3.723 -8.316 -8.315 -8.316 s -8.315 3.723 -8.315 8.316 v 5.043 c 0 4.592 3.723 8.315 8.315 8.315 S 68.317 21.753 68.317 17.16 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(194,173,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 53.317 52.359 v -5.043 c 0 -4.592 -3.723 -8.315 -8.315 -8.315 s -8.315 3.723 -8.315 8.315 v 5.043 c 0 4.592 3.723 8.315 8.315 8.315 S 53.317 56.952 53.317 52.359 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(128,170,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 83.318 52.359 v -5.043 c 0 -4.592 -3.723 -8.315 -8.315 -8.315 c -4.592 0 -8.315 3.723 -8.315 8.315 v 5.043 c 0 4.592 3.723 8.315 8.315 8.315 C 79.595 60.675 83.318 56.952 83.318 52.359 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(128,170,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 23.316 52.359 v -5.043 c 0 -4.592 -3.723 -8.315 -8.315 -8.315 s -8.315 3.723 -8.315 8.315 v 5.043 c 0 4.592 3.723 8.315 8.315 8.315 S 23.316 56.952 23.316 52.359 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(128,170,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 55.983 47.317 v 5.043 c 0 2.437 -0.807 4.683 -2.155 6.506 c 2.481 0.929 4.621 2.562 6.173 4.655 c 1.552 -2.094 3.692 -3.727 6.173 -4.655 c -1.348 -1.824 -2.155 -4.07 -2.155 -6.506 v -5.043 c 0 -6.054 4.924 -10.98 10.979 -10.982 c -0.036 -6.003 -4.91 -10.859 -10.921 -10.859 h -4.076 h -4.076 c -6.011 0 -10.885 4.856 -10.921 10.859 C 51.058 36.336 55.983 41.262 55.983 47.317 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(194,173,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 25.983 47.317 v 5.043 c 0 2.437 -0.807 4.683 -2.155 6.506 c 2.481 0.929 4.621 2.562 6.173 4.655 c 1.553 -2.094 3.692 -3.727 6.173 -4.655 c -1.348 -1.824 -2.155 -4.07 -2.155 -6.506 v -5.043 c 0 -6.054 4.925 -10.98 10.979 -10.982 c -0.036 -6.003 -4.91 -10.859 -10.921 -10.859 h -4.076 h -4.076 c -6.011 0 -10.885 4.856 -10.921 10.859 C 21.058 36.336 25.983 41.262 25.983 47.317 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(194,173,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 90 71.549 c -0.027 -6.01 -4.905 -10.874 -10.922 -10.874 h -4.076 h -4.076 c -6.033 0 -10.924 4.891 -10.924 10.924 c 0 -6.033 -4.891 -10.924 -10.924 -10.924 h -4.076 h -4.076 c -6.033 0 -10.924 4.891 -10.924 10.924 c 0 -6.033 -4.891 -10.924 -10.924 -10.924 H 15 h -4.076 C 4.891 60.675 0 65.566 0 71.599 v 14.599 h 30.001 h 30.001 H 90 V 71.549 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(128,170,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrpIcone);
export default __webpack_public_path__ + "static/media/grp_icone.ee72f44699b02604b42ac320c4197d2c.svg";
export { ForwardRef as ReactComponent };